import React, { useState } from 'react';

/**
 * Reusable tab bar.
 * @param {Array} items - Array of tab label strings
 * @param {number} defaultActive - Index of default active tab
 * @param {function} onTabChange - Callback with active index
 */
const Tabs = ({ items = [], defaultActive = 0, onTabChange }) => {
  const [active, setActive] = useState(defaultActive);

  const handleClick = (index) => {
    setActive(index);
    if (onTabChange) onTabChange(index);
  };

  return (
    <div className="tabs">
      {items.map((label, index) => (
        <button
          className={`tabs__item${index === active ? ' tabs__item--active' : ''}`}
          key={label}
          onClick={() => handleClick(index)}
        >
          {label}
        </button>
      ))}
    </div>
  );
};

export default Tabs;
